<template>
  <div id="quoteThree"></div>
</template>

<script>
export default {
  name: "QuoteThree",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        quote:
          "Using LinkedIn without consistency is like *a ship without a compass*.",
        author: "John Doe",
        author_bio: "Author is a software engineer at Google",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler(newVal) {
        console.log("scale", newVal);
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    render() {
      const quoteThree = document.getElementById("quoteThree");
      if (!quoteThree) return;
      quoteThree.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const fontSize = exporting ? 56 : 56 * this.scale;
      const logoHeight = exporting ? 45 : 45 * this.scale;
      const authorSize = exporting ? 28 : 28 * this.scale;
      const bioSize = exporting ? 22 : 22 * this.scale;
      const chipSize = exporting ? 18 : 18 * this.scale;
      const quoteMarkSize = exporting ? 400 : 400 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.dark || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#e63946";

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background-color: #fafafa;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Giant decorative quote mark -->
          <div style="
            position: absolute;
            top: -40px;
            left: 40px;
            font-size: ${quoteMarkSize}px;
            font-family: 'Playfair Display', 'Georgia', serif;
            font-weight: 500;
            color: #000000;
            opacity: 0.06;
            line-height: 1;
            pointer-events: none;
            user-select: none;
          ">"</div>

          <!-- Header with logo -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <img
              src="${logoSrc}"
              height="${logoHeight}px"
              alt=""
            />
          </div>

          <!-- Quote content -->
          <div style="padding: 0 8% 8% 8%; position: relative; z-index: 1;">
            <div style="
              font-size: ${fontSize}px;
              font-family: 'Playfair Display', 'Georgia', serif;
              font-weight: 500;
              color: #1a1a1a;
              line-height: 1.35;
              letter-spacing: -0.01em;
              margin-bottom: 48px;
              max-width: 90%;
            ">${this.data.quote.replace(
              /\*([^*]+)\*/g,
              '<span class="template-libre">$1</span>',
            )}</div>

            <div style="margin-bottom: 32px;">
              <p style="
                color: #1a1a1a;
                font-size: ${authorSize}px;
                margin: 0;
                font-weight: 700;
                font-family: 'Inter', 'Helvetica Neue', sans-serif;
                letter-spacing: -0.01em;
                display: inline-block;
                position: relative;
              ">
                ${this.data.author}
                <span style="
                  position: absolute;
                  bottom: -8px;
                  left: 0;
                  width: 100%;
                  height: 4px;
                  background: ${primaryColor};
                "></span>
              </p>
              <p style="
                color: #666666;
                font-size: ${bioSize}px;
                margin: 16px 0 0 0;
                font-weight: 400;
                font-family: 'Inter', 'Helvetica Neue', sans-serif;
              ">${this.data.author_bio}</p>
            </div>

            <!-- Chip -->
            <div style="display: flex;">
              <span
                style="
                  display: inline-block;
                  background: #1a1a1a;
                  color: #ffffff;
                  font-size: ${chipSize}px;
                  font-weight: 600;
                  border-radius: 4px;
                  padding: 12px 20px;
                  letter-spacing: 0.08em;
                  text-transform: uppercase;
                  font-family: 'Inter', 'Helvetica Neue', sans-serif;
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>
